<template>
<div class="chapter">
<div class="inner_page">
<p><br/>
<br/></p>
<h1 class="sigil_not_in_toc" id="pgepubid00000"> ON THE PAMPAS</h1>
<h2 class="c2 sigil_not_in_toc" id="pgepubid00001">THE YOUNG SETTLERS</h2>
<p><br/></p>
<h5 class="sigil_not_in_toc">BY</h5>
<h3 class="sigil_not_in_toc" id="pgepubid00002">G. A. HENTY</h3>
<div class="center smfont">
    AUTHOR OF ‘THE YOUNG FRANC-TIREURS,’ ‘THE YOUNG BUGLERS,’<br/>
    ‘THE MARCH TO MAGDALA,’ ETC. ETC.<br/>
<br/>
<br/>
    WITH ILLUSTRATIONS BY J. B. ZWECKER.<br/>
<br/>
</div>
<div class="figcenter">
<br/>
<img alt="G F" height="57" src="Images/002.jpg" title="" width="75"/><br/>
</div>
<p class="center"><b>LONDON</b><br/>
  GRIFFITH  FARRAN  &amp;  CO.<br/>
<span class="smfont">NEWBERY HOUSE, 39 CHARING CROSS ROAD</span><br/></p>
<p><br/>
<br/>
<br/></p>
<p class="center smfont"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main_0001_0001.vue?31c96c75